import { render, staticRenderFns } from "./StarRatingInput.vue?vue&type=template&id=5ae0e332&scoped=true&"
import script from "./StarRatingInput.vue?vue&type=script&lang=js&"
export * from "./StarRatingInput.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingInput.vue?vue&type=style&index=0&id=5ae0e332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae0e332",
  null
  
)

export default component.exports